function handleCategoryChange(event, clickedElement) {
  const prevActiveEle = clickedElement.parentElement.querySelector('.active-category');
  if (prevActiveEle === clickedElement) {
    return;
  }
  prevActiveEle.classList.remove('active-category');
  clickedElement.classList.add('active-category');
  const {
    dataset: { categoryId },
  } = clickedElement;
  if (document.querySelector('.gyb-card-list')) {
    [...document.querySelector('.gyb-card-list').children].forEach((card) => {
      if (card.classList.contains(categoryId)) {
        card.classList.remove('d-none');
      } else {
        card.classList.add('d-none');
      }
    });
  }
}

(function attachGybCardActions() {
  [...document.querySelectorAll('.list-category')].forEach((element) => {
    element.addEventListener('click', (event) => {
      event.stopPropagation();
      const listElement = event.target.nodeName !== 'LI' ? element.closest('.list-category') : element;
      handleCategoryChange(event, listElement);
    });
  });
}());
